import { capitalize } from 'lodash';
import styles from './index.module.scss';
import { formatTime, diff } from '../../../../../../../services/timeService';
import { unitOfTime } from '../../../../../../../services/timeService/types';
import { IEMRPatient } from '../../../../../../../services/intakeDataService/emrPatientsService/types';

const EMRPatientInfo = ({ firstName, lastName, gender, birthDate }: IEMRPatient) => {
  return (
    <div className={'flex items-center flex-grow'}>
      <div className={'w-full'}>
        {firstName || lastName ? (
          <div className={styles.pateintName}>
            <span>Name:</span> {firstName} {lastName}
          </div>
        ) : null}
        {birthDate ? (
          <div>
            <span>Date of birth:</span> {formatTime(birthDate)}
          </div>
        ) : null}
      </div>
      <div className={'w-full'}>
        {gender ? (
          <div>
            <span>Sex:</span> <>{capitalize(gender)}</>
          </div>
        ) : null}
        {birthDate ? (
          <div>
            <span>Age:</span> {diff(birthDate, unitOfTime.years)}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EMRPatientInfo;
